import React from "react";
import { arrayOf, func, string } from "prop-types";

import TestDriveType from "./TestDriveType";

import { testDriveType } from "@types";

const TestDriveTypesList = ({ testDriveTypes, setTypeFilter, affiliation }) => (
  <div className="flex flex-col gap-4">
    {(testDriveTypes || [])
      .filter(testDriveType => testDriveType.status)
      .map(testDriveType => (
        <TestDriveType
          affiliation={affiliation}
          key={testDriveType.id}
          setTypeFilter={setTypeFilter}
          testDriveType={testDriveType}
        />
      ))}
  </div>
);

TestDriveTypesList.propTypes = {
  testDriveTypes: arrayOf(testDriveType),
  setTypeFilter: func,
  affiliation: string,
};

export default TestDriveTypesList;
